export default __webpack_public_path__ + "static/media/Group 3419.33f39bfe.png";